import {
  Box,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import React from 'react';

import Modal from '../../../../components/Modal';

function MoveColoursModal({
  open,
  handleClose,
  selectedColours,
  colourGroupName,
  handleMoveColours,
  selectedNewColourGroupName,
  setSelectedNewColourGroupName,
  swatchColoursName,
  translatedSwatchColoursName,
  languageId,
  langName,
}) {
  const totalSelected = (selectedColours.length > 0) ? selectedColours.length : 0;
  const mainColours = (swatchColoursName !== undefined && languageId === 1) ? swatchColoursName.map((x) => x.SwatchColour1) : [];
  const translatedColours = (translatedSwatchColoursName !== undefined && languageId !== 1) ? translatedSwatchColoursName : [];

  return (

    <Modal
      open={open}
      onClose={handleClose}
      title="Move selected Swatch colours"
      containerWidth="md"
      disableButton={!selectedNewColourGroupName.length}
      titleVariant="h4"
      desktopModalWidth="50%"
      desktopModalHeight="50vh"
      buttonLabel="SAVE"
      buttonOnClick={handleMoveColours}
      buttonColour="primary"
      roundedButton
    >
      <Typography className="text-lg font-bold text-center text-red-700 -mt-9">
        {totalSelected}
        {' '}
        selected
      </Typography>
      <Box display="flex" gap={1}>
        <Stack className="w-1/2">
          <Box
            sx={{
              borderRadius: '4px',
              padding: '16px 8px 8px 8px',
              overflow: 'auto',
            }}
          >
            <span className="text-lg font-bold text-red-700">FROM</span>
            {' '}
            <span className="text-3xl font-bold">{colourGroupName}</span>
            <Divider flexItem variant="middle" />
            <div className="overflow-y-auto custom-scrollbar max-h-52">
              {selectedColours.map((colour) => (
                <Typography variant="h6">
                  {colour}
                </Typography>
              ))}
            </div>

          </Box>
        </Stack>
        <Divider orientation="vertical" variant="middle" flexItem />
        <Stack className="w-1/2 mt-2">
          <Box
            sx={{
              alignItems: 'center',
              borderRadius: '4px',
              padding: '16px 8px 8px 8px',
              maxHeight: 300,
              overflow: 'auto',
            }}
          >
            <span className="text-lg font-bold text-green-700 align-middle">NEW</span>
            {/* <Divider className="pt-2 font-bold" /> */}
            <Autocomplete
              autoHighlight
              getOptionDisabled={(option) => option === colourGroupName}
              disablePortal
              options={languageId === 1 ? mainColours : translatedColours}
              sx={{ width: 300, pt: 3 }}
              inputValue={selectedNewColourGroupName}
              onInputChange={(event, newInputValue) => {
                setSelectedNewColourGroupName(newInputValue);
              }}
              renderInput={(params) => <TextField {...params} label={(languageId === 1) ? 'Primary Colours' : `${langName} Colours`} />}
            />
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
}
export default MoveColoursModal;
